<template>
  <div class="upload">
    <slot name="files" :files="files"></slot>
    <FileUpload
      v-bind="$attrs"
      :input-id="Math.random()"
      class="v-file-upload"
      :headers="{ Authorization: `Token ${token}` }"
      :post-action="postAction"
      :response="fileResponse"
      :accept="accept"
      v-model="files"
      :multiple="multiple"
      @input="updatetValue"
      @input-filter="inputFilter"
      @input-file="inputFile"
      ref="upload">
      <slot></slot>
    </FileUpload>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import cookie from '@/module/utils/cookie'

// 工单/反馈附件允许的扩展名；accept 与 inputFilter 共用同一份名单
const uploadAllowedExtensions = [
  'jpg',
  'jpeg',
  'webp',
  'png',
  'docx',
  'xlsx',
  'zip',
  'pdf',
  'txt',
  'mp4',
  'pfx',
  'crt',
  'cert',
  'key'
]

export default {
  name: 'upload',
  components: {
    FileUpload
  },
  data() {
    return {
      files: this.value,
      attachments: [],
      fileResponse: {},
      uploadAllowedExtensions
    }
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    postAction: {
      type: String,
      default: '/v1/attachments/upload/'
    },
    multiple: {
      type: Boolean,
      default: true
    }
    // limitSize : {
    //     type : Object ,
    //     default(){
    //         return {
    //             size : 1024*1024*20 ,
    //             error : 'File size exceeds 20M'
    //         }
    //     }
    // }
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.files = val
      }
    },
    files: {
      deep: true,
      handler() {
        this.$emit('input', this.files)
      }
    }
  },
  computed: {
    token() {
      return cookie.get('token')
    },
    accept() {
      return this.uploadAllowedExtensions.map((ext) => `.${ext}`).join(',')
    },
    allowedExtensionPattern() {
      return new RegExp('\\.(' + this.uploadAllowedExtensions.join('|') + ')$', 'i')
    }
  },
  methods: {
    updatetValue(value) {
      this.files = value
    },
    inputFilter(newFile, oldFile, prevent) {
      // 白名单外文件静默丢弃，不进入上传列表
      if (newFile && !this.allowedExtensionPattern.test(newFile.name)) {
        return prevent()
      }
      this.$emit('input-filter', newFile, oldFile, prevent)
    },
    inputFile(newFile, oldFile) {
      // if (newFile.active && !oldFile.active) {
      //     if (newFile.size >= 0 && newFile.size > this.limitSize.size) {
      //         this.$refs.upload.update(newFile, { error:  this.limitSize.error })
      //     }
      // }
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    getUploaded() {
      return this.$refs.upload.uploaded
    }
  },
  created() {
    this.files = []
  }
}
</script>

<style lang="scss">
.file-uploads label {
  cursor: pointer;
}
</style>
